let Vue

function extend (Vue) {
	Vue.directive('inputUI', {
		inserted (el) {
			const input = el.querySelector('input, textarea')
			const label = el.querySelector('label')

			if (!input || !label) return

			// Activer le label si le champ a une valeur
			if (input.value && input.value.trim() !== '') {
				label.classList.add('active')
			}

			// Activer le label pour les champs de type date
			if (input.tagName === 'INPUT' && input.type === 'date') {
				label.classList.add('active')
			}

			// Focus event
			input.addEventListener('focus', () => {
				label.classList.add('active')
			})

			// Blur event
			input.addEventListener('blur', () => {
				if (!input.value || input.value.trim() === '') {
					label.classList.remove('active')
				}

				// Garder le label actif pour les champs de type date
				if (input.tagName === 'INPUT' && input.type === 'date') {
					label.classList.add('active')
				}
			})
		},

		update (el) {
			const input = el.querySelector('input, textarea')
			const label = el.querySelector('label')

			if (!input || !label) return

			// Mettre à jour la classe active en fonction de la valeur
			if (input.value && input.value.trim() !== '') {
				label.classList.add('active')
			} else if (!(input.tagName === 'INPUT' && input.type === 'date')) {
				label.classList.remove('active')
			}
		}
	})
}

function _install (_Vue) {
	Vue = _Vue
	extend(Vue)
}

let inputUI = function inputUI (options = {}) {}

inputUI.install = _install
inputUI.version = '0.0.1'

export default inputUI



// WEBPACK FOOTER //
// ./src/common/directives/inputUI.js